import {
  CONSIGNMENT_STATUS,
  type CancellationReason,
  type ConsignmentStatusAction,
  type ConsignmentStatusCode
} from '@/entities/consignments';

/** A status change as the reason dialog shows it: the action sent to the backend and the status it leads to. */
export interface ConsignmentStatusTarget {
  action: ConsignmentStatusAction;
  /** Null for a reset whose target the backend has not resolved, or a bulk reset landing on different statuses. */
  statusCode: ConsignmentStatusCode | null;
}

export interface ConsignmentStatusChangeValues {
  reason: CancellationReason;
  comment: string;
}

/** Status each action leads to. `RESET` has none of its own: the backend resolves it per consignment (`resetTargetStatusCode`). */
export const ACTION_TARGET_STATUS: Record<ConsignmentStatusAction, ConsignmentStatusCode | null> = {
  ACCEPT: CONSIGNMENT_STATUS.AC,
  SET_ON_HOLD: CONSIGNMENT_STATUS.OH,
  CANCEL: CONSIGNMENT_STATUS.CA,
  RESET: null
};
